<template>
  <div class="receive-order-settings-three">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="所属社区">{{info.community}}</a-form-model-item>
      <a-form-model-item label="房间号">{{info.houses_tree_branch}}</a-form-model-item>
      <a-form-model-item label="应收金额">{{info.price}}</a-form-model-item>
      <a-form-model-item label="备注" prop="content">
        <a-textarea v-model="form.content" placeholder="请输入备注"></a-textarea>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import {
    receiveOrderPayStatusText
  } from '@/io/dict.js';
  import CommunityService from '@/io/community.js';
  import ExpendService from '@/io/expend.js';

  export default {
    name: 'ReceiveOrderSettingsOne',
    props: {
      id: {
        type: Number,
        default() {
          return null
        }
      }
    },
    data() {
      return {
        receiveOrderPayStatusText,
        info: {},
        communityOptions: [],
        form: {
          content: null
        },
        rules: {
          content: [
            {
              required: true,
              message: '请输入备注'
            }
          ],
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.initCommunity().then(() => {
            this.initPage();
          });
        },
        immediate: true
      },
    },
    methods: {
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initPage() {
        if (this.id) {
          ExpendService.orderInfo(this.id).then(res => {
            this.info = {
              ...res,
              community: this.communityOptions.filter(val => val.id === res.community_id)[0].name
            };
            this.form.content = res.remark;
          }).catch(err => {});
        }
      },
      submit(callback = () => {}) {
        this.$beforeFormSubmit(this.$refs.form, () => {
          ExpendService.orderSettingsFour(
            this.id,
            this.form.content
          ).then(res => {
            this.$afterFormSubmit('编辑成功', () => {
              callback();
            });
          }).catch(err => {});
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  
</style>